import i18n from "../../../i18n";
import { hasProp } from "../../../helpers/Class";
import CarrierTax from "./CarrierTax";
import CarrierDestination from "./CarrierDestination";
import CarrierArea from "./CarrierArea";

class Carrier {
    constructor(carrier = null) {
        this.id = !hasProp(carrier, "id") ? undefined : carrier.id;
        this.name = !hasProp(carrier, "name") ? undefined : carrier.name;
        this.enabled = !hasProp(carrier, "enabled") ? true : carrier.enabled;
        this.enabledForProduction = !hasProp(carrier, "enabledForProduction") ? true : carrier.enabledForProduction;
        this.enabledForDistribution = !hasProp(carrier, "enabledForDistribution") ? true : carrier.enabledForDistribution;
        this.maxWeight = !hasProp(carrier, "maxWeight") ? null : carrier.maxWeight;
        this.needsGLN = !hasProp(carrier, "needsGLN") ? false : carrier.needsGLN;
        this.private = !hasProp(carrier, "private") ? false : carrier.private;
        this.chargesBy = !hasProp(carrier, "chargesBy") ? undefined : carrier.chargesBy;
        this.currency = !hasProp(carrier, "currency") ? null : carrier.currency;

        this.destinations = [];
        if (carrier !== null && carrier.destinations) {
            this.destinations = carrier.destinations.map(destination => new CarrierDestination(destination));
        }
        this.areas = [];
        if (carrier !== null && carrier.areas) {
            this.areas = carrier.areas.map(area => new CarrierArea(area));
        }
        this.taxes = [];
        if (carrier !== null && carrier.taxes) {
            this.taxes = carrier.taxes.map(tax => new CarrierTax(tax));
        }
    }

    sanitizeForAPI() {
        if (this.maxWeight !== undefined && typeof this.maxWeight !== "number" &&
            (this.maxWeight === null || this.maxWeight.trim() === "")) {
            this.maxWeight = null;
        }
    }

    get chargesByLabel() {
        const chargesByLabels = {
            weight: i18n.t("CarrierClass.byWeight"),
            lot: i18n.t("CarrierClass.byLot"),
            quantity: i18n.t("CarrierClass.byQuantity"),
        };
        return chargesByLabels[this.chargesBy];
    }
}

export default Carrier;